<!-- 左边资源的列表 -->
<template>
  <div class="PageLeftResource">
    <!-- 头部的视频预览 -->
    <div class="PreviewTop">
      <div class="PreviewTitle">
        <span class="ViewerLabel">{{ $t('lang.Viewer') }}</span>
        <span class="ViewerTitle">{{videoName}}</span>
      </div>
      <div class="PreviewBox">
        <div class="PreviewBoxContent" v-loading="extPreviewLoad">
          <video v-if="PreviewSwitch == 0" id="videoMp8" :style="StyleMessage" disablePictureInPicture :featuresFullscreenResize="true" x5-playsinline="" playsinline="" webkit-playsinline="" class="videoTv video-js vjs-default-skin vjs-big-play-centered" controls="controls" name="media" muted="muted" preload="auto" notSupportedMessage="此视频暂无法播放，请稍后再试">
            <source :src="videoSrc" type="video/mp4" />
          </video>
          <m3u8-video-preview v-if="PreviewSwitch == 1" :videoMessage="videoMessage" :StyleMessage="StyleMessage"></m3u8-video-preview>
          <video-module
            v-if="PreviewSwitch == 2"
            :height="StyleMessage.height"
            :width="StyleMessage.width"
            :source="socketData"
            deviceType="T"
            :rid="socketData.livePeerId"
            :oldReceiverInfoObj="socketData"
            :oldGetKernelStateObj="socketData"
            :useOldR="false"
            :sid="socketData.peerId"
            :status="socketData.status"
          />
          <div :class="['ejectIcon',{'ejectIconZ':PreviewSwitch}]" @click="EjectIcon">
            <i class="iconfont icon-eject"></i>
          </div>
        </div>
      </div>
    </div>
    <!-- 中间横线 -->
    <div class="transverseLine">
    </div>
    <!-- 下面的资源展示 -->
    <div class="BottomResource">
      <div class="LeftClassify">
        <div v-for="(item,index) in ClassifyList" :key="index">
          <div :class="['SortChunk',{ 'PitchSortChunk': PitchClass == item.type}]" @click="changeLeftSource(item)" v-if="!(WhichPage == 'Playout' && !item.switch)">
            <div>
              <i :class="['iconfont',item.icon]"></i>
              <p>{{$t(item.name)}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="RightResourceList">
        <public-file-tree v-if="PitchClass == 'Media'" :renderNode="renderNode" @SetPreviewVideo="SetPreviewVideo"></public-file-tree>
        <source-list v-if="PitchClass == 'Live Source'" @SetPreviewVideo="SetPreviewVideo"></source-list>
        <program-template-list v-if="PitchClass == 'Program Template'" @editTemplate="editTemplate"></program-template-list>
        <Schedule-template-list v-if="PitchClass == 'Schedule Template'" @editTemplate="editTemplate"></Schedule-template-list>
        <search-and-repalce v-if="PitchClass == 'SearchAndRepalce'"></search-and-repalce>
      </div>
    </div>
     <!-- 大分辨率提示 -->
    <div class="BigResolution" v-if="!resolutionRatio">
      <i class="iconfont icon-tishi"></i>
      <span>{{$t('lang.ResolutionRatio')}}</span>
    </div>
  </div>
</template>

<script>
import Bus from '@/assets/js/vueBus.js'
import Outil from '@/assets/js/utils.js'
import PublicFileTree from '@/components/common/PublicFileTree.vue'
import SourceList from '@/components/file/SourceList.vue'
import ProgramTemplateList from '@/components/file/ProgramTemplateList.vue'
import ScheduleTemplateList from '@/components/file/ScheduleTemplateList.vue'
import SearchAndRepalce from '@/components/common/SearchAndRepalce.vue'
import videoModule from '@/components/common/VideoC'
import m3u8VideoPreview from '@/components/common/m3u8VideoPreview'
import { mapState } from 'vuex'
import toTips from '@/assets/js/toTipsObj'
import { componentsAnalyze, playoutAnalyze, scheduleAnalyze } from '../../assets/js/googleAnalyze/playout.js'
export default {
  props: {
    // 存在哪个页面
    WhichPage: {
      type: String,
      default: 'Playout' // Scheduler和Playout 分别是两个页面
    }
  },
  watch: {
    // 监听导航
    PitchClass (newdata, olddata) {
      if (newdata == 'Schedule Template' || newdata == 'SearchAndRepalce') {
        this.editTemplate({
          status: false,
          name: 'programTemplate'
        })
      }
    },
    // 行为同步
    'State.BehaviorChange' (data) {
      console.log('media-Common')
      if (typeof data != 'object') {
        return
      }
      if (data.action == 'MediaListChange') {
        this.renderNode++
      }
    },
    // 用户权限
    UserChannelPermission: {
      handler (data) {
        if (data == 5) {
          this.ClassifyList.forEach((item) => {
            if (item.type == 'Live Source') {
              item.switch = true
              this.PitchClass = 'Live Source'
            } else {
              item.switch = false
            }
          })
        }
      },
      immediate: true
    }
  },
  data () {
    return {
      // 左边类别列表
      ClassifyList: [
        {
          name: 'lang.Media',
          icon: 'icon-video1',
          switch: true,
          type: 'Media',
          tname: 'Media'
        },
        {
          name: 'lang.LiveSource',
          icon: 'icon-Live',
          switch: true,
          type: 'Live Source',
          tname: 'liveSource'
        },
        {
          name: 'lang.programTemplate',
          icon: 'icon-template',
          switch: true,
          type: 'Program Template',
          tname: 'programTemplate'
        },
        {
          name: 'lang.scheduleTemplate',
          icon: 'icon-calendar',
          switch: false,
          type: 'Schedule Template',
          tname: 'scheduleTemplate'
        },
        {
          name: 'lang.SearchAndRepalce',
          icon: 'icon-search',
          switch: false,
          type: 'SearchAndRepalce',
          tname: 'searchAndRepalce'
        }
      ],
      // 选中的类别
      PitchClass: 'Media',
      // 视频文件信息
      videoMessage: {},
      // 视频的url
      videoSrc: '',
      // 视频名字
      videoName: '',
      // source对应的r的信息
      SourceLiveR: {
        id: '',
        type: ''
      },
      // r的信息
      selectR: {},
      // 选中source正在live的信息
      socketData: {},
      // 两种预览开关
      PreviewSwitch: 0, // 0 mp4 1 m3u8 2 source
      // 刷新树形文件夹
      renderNode: 0,
      pageMark: '',
      // 预览视频样式问题
      StyleMessage: {
        width: '400px',
        height: '228px'
      },
      // 分辨率提示
      resolutionRatio: true,
      BigResolutionTime: null,
      // 上一个ext的PeerId
      beforePeerId: '',
      // ext预览Id
      PreviewLink: '',
      extPreviewLoad: false
    }
  },
  components: {
    PublicFileTree,
    SourceList,
    ProgramTemplateList,
    ScheduleTemplateList,
    videoModule,
    m3u8VideoPreview,
    SearchAndRepalce
  },
  computed: {
    ...mapState({
      State: (state) => state,
      pageRWebsocket: (state) => state.websocket.pageRWebsocket,
      pageSerBusRequest: (state) => state.websocket.pageSerBusRequest,
      // 用户权限
      UserChannelPermission: (state) => state.playout.UserChannelPermission,
      CloneDisabled: (state) => state.playout.CloneDisabled
    })
  },
  created () {
    const ProgramRMessage = Outil.getProgramReceiver()
    if (ProgramRMessage) {
      this.$nextTick(() => {
        this.currentSelectData(ProgramRMessage)
      })
    } else {
      this.$router.push({
        path: '/wb'
      })
    }
  },
  mounted () {
    this.hideSearch()
    this.getCurrentPage()
    this.hideLeftClass()
    // source预览
    Bus.$on('SourcePreview', (data) => {
      // SourceLiveR.type: ext,SDT,Live   data.type: ext,anywhere,gridPack,gridSDI等
      if (data.rid == this.SourceLiveR.id) {
        data.data.SDI = this.SourceLiveR.type == 'SDI'
        if (data.type == 'ext') {
          data.data.SDI = true
          data.data.WebRSDIFeedUrl = this.PreviewLink
        } else if (this.SourceLiveR.type == 'Live') {
          data.data.SDI = true
          data.data.WebRSDIFeedUrl = data.data.WebRM3U8PlaybackUrl
        }
        this.socketData = data.data
      }
    })
    if (!this.pageSerBusRequest) {
      this.$createWebsocket.pageSerBusRequest()
    }
    this.WebpageWidthChange()
  },
  methods: {
    hideLeftClass () {
      console.log(this.CloneDisabled)
      this.ClassifyList.forEach((item) => {
        // if(this.WhichPage=='Playout')
        if (this.WhichPage == 'Scheduler') {
          item.switch = !this.CloneDisabled[item.tname]
        } else if (this.WhichPage == 'Playout' && item.tname != 'searchAndRepalce' && item.tname != 'scheduleTemplate') {
          item.switch = !this.CloneDisabled[item.tname]
        }
      })
    },
    // disable模式search隐藏
    hideSearch () {
      this.ClassifyList.forEach(v => {
        if (v.type == 'SearchAndRepalce' && this.CloneDisabled.disableButton) {
          v.switch = false
        }
      })
    },
    // 监听屏幕宽度变化
    WebpageWidthChange () {
      const $this = this
      $this.controlVideoWidth($this)
      $(window).resize(() => {
        $this.controlVideoWidth($this)
      })
    },
    // 控制视频宽度变化
    controlVideoWidth ($this) {
      const docWidth = document.body.clientWidth
      let videoWidth = 400
      if (docWidth > 1480) {
        videoWidth = 400
      } else if (docWidth > 1330 && docWidth <= 1480) {
        videoWidth = 326
      } else if (docWidth <= 1330) {
        videoWidth = 290
      }
      const videoHeight = videoWidth / 400 * 228
      $this.StyleMessage.width = `${videoWidth}px`
      $this.StyleMessage.height = `${videoHeight}px`

      // 分辨率太高提示
      if ($this.WhichPage == 'Scheduler' && docWidth > 2400 && $this.resolutionRatio) {
        $this.resolutionRatio = false
        if (this.BigResolutionTime) {
          clearTimeout(this.BigResolutionTime)
          this.BigResolutionTime = null
        }
        this.BigResolutionTime = setTimeout(() => {
          $this.resolutionRatio = true
        }, 3000)
      }
    },
    // 获取当前页面
    getCurrentPage () {
      this.pageMark = window.location.hash.split('#')[1]
    },
    // 切换资源tab
    changeLeftSource (item) {
      this.PitchClass = item.type
      const leftSource = this.PitchClass.replace(' ', '')
      if (this.pageMark === '/po') {
        scheduleAnalyze(`schedulerLeftSource${leftSource}`, '/po')
      }
      if (this.pageMark === '/pop') {
        playoutAnalyze(`playoutLeftSource${leftSource}`, '/pop')
      }
    },
    // 当前channelR的信息
    currentSelectData (item) {
      this.selectR = JSON.parse(JSON.stringify(item))
      this.$emit('currentSelectData', item)
      Bus.$emit('playOutVideoR', item)
    },
    // 清空视频播放
    EjectIcon () {
      if (this.pageMark === '/po') {
        scheduleAnalyze('schedulerLeftSourceClearVideo', '/po')
      }
      if (this.pageMark === '/pop') {
        playoutAnalyze('playoutLeftSourceClearVideo', '/pop')
      }
      // 视频预览清除
      const vdo = document.getElementById('videoMp8')
      if (vdo) {
        vdo.src = ''
        this.videoSrc = ''
      }
      // 判断ext
      if (this.SourceLiveR.type == 'ext') {
        this.ClearExtPreview()
      }
      this.videoName = ''
      this.SourceLiveR = {
        id: '',
        type: ''
      }
      this.socketData = {}
      // source预览清除
      this.PreviewSwitch = 0
      this.EndSchedulerWebsocket()
    },
    // 清除ext
    ClearExtPreview () {
      this.StopExtWebsocket()
      const programId = this.$BehaviorSyns.getProgramId()
      if (!programId) return
      const param = {
        programId
      }
      this.axios
        .post('/gatewayPlayoutUrl/tvu-playout/preview/preExtEnd', param)
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            this.beforePeerId = ''
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }).catch(() => {})
    },
    // 编辑模板
    editTemplate (item) {
      componentsAnalyze('pageLeftResourceEditTemplate', '/ponent')
      this.$emit('editTemplate', item)
    },
    // 设置预览视频
    async SetPreviewVideo (data, type) {
      componentsAnalyze('pageLeftResourceSetPreviewVideo', '/ponent')
      let CurrentR = false
      // 判断上一次预览是ext,这次不是ext
      if (this.SourceLiveR.type == 'ext' && type != 'ext') {
        this.ClearExtPreview()
      }
      if (type == 'Media') {
        this.EjectIcon()
        if (Outil.FileNameSuffix(data.name) == 'json') {
          Outil.getJsonMessage(data).then((res) => {
            if (res.data.errorCode == '0x0') {
              this.PreviewSwitch = 1
              let filePath = res.data.result.filePath
              if (filePath.indexOf('http:') == 0) {
                filePath = filePath.replace('http:', 'https:')
              }
              data.filePath = filePath
              this.videoMessage = data
              this.videoName = data.name
            } else {
              const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
              this.$message.info(errorInfo)
            }
          }).catch(() => {})
        } else {
          this.PreviewSwitch = 0
          this.$nextTick(() => {
            const vdo = document.getElementById('videoMp8')
            if (vdo) {
              vdo.src = data.url
              try {
                vdo.pause()
                vdo.load()
                const playPromise = vdo.play()
                playPromise.then(() => {

                }).catch((err) => {
                  console.log(err)
                })
              } catch (error) {
                console.log(error)
              }
              this.videoSrc = data.url
              this.videoName = data.name
            }
          })
        }
        this.EndSchedulerWebsocket()
      } else {
        let livePeerId = ''
        if (type == 'ext') {
          const RMessage = Outil.getProgramReceiver() ? Outil.getProgramReceiver() : {}
          this.SourceLiveR.type = 'ext'
          const getPreviewUrl = await this.getPreviewUrl(data)
          if (getPreviewUrl) {
            livePeerId = RMessage.peerId
            this.ExtWebsocket()
          } else {
            this.PreviewSwitch = 0
            // 之前有在预览清除掉
            if (this.beforePeerId) {
              this.ClearExtPreview()
            }
            return
          }
        } else {
          if (type == 'gridSDI' || type == 'gridPack') {
            // 判断是否的是Grid
            if (data.peerId.length == 32) {
              const SDIpeerId = [data.peerId.substr(0, 16), data.peerId.substr(16, 16)]
              // 判断是否是SDI连接
              if (SDIpeerId[1] == '0000000000000002') {
                livePeerId = SDIpeerId[0]
                this.SourceLiveR.type = 'SDI'
              } else if (SDIpeerId[1] == '0000000000000001') {
                livePeerId = SDIpeerId[0]
                this.SourceLiveR.type = 'Live'
              } else {
                console.log('是Grid，但获取不到peerId')
              }
            }
          } else if (data.status == 2) {
            // 判断是否live
            livePeerId = data.livePeerId
            this.SourceLiveR.type = 'Live'
            // 判断与当前r是否在Live
            const Rid = Outil.getProgramReceiver('peerId')
            if (livePeerId == Rid) CurrentR = true
          }
        }
        // 与当前r在Live
        if (CurrentR) {
          this.$message.info(this.$t('lang.NoCurrentR'))
          return
        }
        // livePeerId没有值即不能预览
        if (!livePeerId) {
          this.$message.info(this.$t('lang.NoLiveView'))
          this.EjectIcon()
          this.EndSchedulerWebsocket()
          return
        }
        this.socketData = {}
        this.videoName = data.name
        this.SourceLiveR.id = livePeerId
        if (this.PreviewSwitch == 2) {
          this.PreviewSwitch = 0
          this.$nextTick(() => {
            this.PreviewSwitch = 2
          })
        } else {
          this.PreviewSwitch = 2
        }
        // 判断是scheduler页面
        if (this.WhichPage == 'Scheduler') {
          this.EndSchedulerWebsocket()
          this.SchedulerPreview(livePeerId)
        }
      }
    },
    // scheduler页面预览的websocket
    SchedulerPreview (rid) {
      this.pageRWebsocket.send({
        message: { rid, categoryId: '2152857600', operationType: '102' },
        time: 1000,
        isOnce: false,
        key: 'getQueryKennel',
        success: (res) => {
          const data = res.data ? JSON.parse(res.data) : {}
          if (res.rid == rid) {
            data.SDI = this.SourceLiveR.type == 'SDI'
            if (this.SourceLiveR.type == 'ext') {
              data.SDI = true
              data.WebRSDIFeedUrl = this.PreviewLink
            } else if (this.SourceLiveR.type == 'Live') {
              data.SDI = true
              data.WebRSDIFeedUrl = data.WebRM3U8PlaybackUrl
            }
            this.socketData = data
          }
        }
      })
    },
    // 结束scheduler页面的websocket
    EndSchedulerWebsocket () {
      // 判断是scheduler页面
      if (this.WhichPage == 'Scheduler') {
        if (this.pageRWebsocket) {
          this.$createWebsocket.pageRWebsocket('stop', 'getQueryKennel')
        }
      }
    },
    // websocket获取发送ext信息
    ExtWebsocket () {
      const ProgramId = this.$BehaviorSyns.getProgramId()
      const RMessage = Outil.getProgramReceiver() ? Outil.getProgramReceiver() : {}
      const urlInfo = JSON.parse(localStorage.getItem('channelInitConfig')).urlInfo
      const { websocketServerName } = urlInfo
      this.StopExtWebsocket()
      this.pageSerBusRequest.send({
        message: {
          serverName: websocketServerName,
          data: JSON.stringify({
            data: JSON.stringify({
              rid: RMessage.peerId,
              currentPeerId: this.beforePeerId,
              ProgramId,
              userId: localStorage.getItem('userId')
            }),
            module: 'channelPreviewExtNotClose'
          })
        },
        time: 2000,
        key: 'channelPreviewExtNotClose',
        success: (res) => {
        }
      })
    },
    // 停止预览
    StopExtWebsocket () {
      if (this.$createWebsocket.pageSerBusRequest) {
        this.$createWebsocket.pageSerBusRequest('stop', ['channelPreviewExtNotClose']) // 停止websocket
      }
    },
    // 获取预览的Url
    async getPreviewUrl (data) {
      const programId = this.$BehaviorSyns.getProgramId()
      if (!programId) return
      const currentPeerId = data.peerId ? data.peerId : data.sourceId
      const param = {
        programId,
        currentPeerId,
        beforePeerId: this.beforePeerId
      }
      this.extPreviewLoad = true
      let PreviewLink = ''
      await this.axios
        .post('/gatewayPlayoutUrl/tvu-playout/preview/preExt', param)
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            const PreviewMessage = res.data.result ? JSON.parse(res.data.result) : {}
            this.beforePeerId = currentPeerId
            if (PreviewMessage.PreviewId) {
              PreviewLink = PreviewMessage.PreviewId
              this.PreviewLink = PreviewMessage.PreviewId
            }
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }).catch(() => {})
      this.extPreviewLoad = false
      return PreviewLink
    },
    // 查询当前r的信息
    async getRMessage (param) {
      await this.axios.get(`/ccp/tvucc-device/device/getDevice?peerId=${param}`).then((res) => {
        if (res.data.errorCode == '0x0') {
          return true
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
        }
      }).catch(() => {})
    }
  },
  beforeDestroy () {
    Bus.$off('SourcePreview')
    console.warn('websocket-PageLeftResource')
    // 两个页面统一一个地方清除r的监听
    Bus.$off('playOutVideoR')
    this.StopExtWebsocket()
    this.EndSchedulerWebsocket()
  }
}
</script>

<style scoped lang="less">
.PageLeftResource {
  min-height: 850px;
  height: 100%;
  border-right: 1px solid #252525;
  .PreviewTop {
    padding: 15px 16px;
    text-align: left;
    .PreviewTitle {
      // display: flex;
      // margin-bottom: 8px;
      span{
        display: inline-block;
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .ViewerLabel {
        width: 55px;
      }
      .ViewerTitle {
        width: calc(100% - 55px)
      }
    }
    .PreviewBox {
      position: relative;
      display: flex;
      justify-content: center;
      .PreviewBoxContent{
        position: relative;
        video {
        width: 100%;
        height: 100%;
        }
        .ejectIcon {
          position: absolute;
          top: 4px;
          right: 4px;
          width: 28px;
          height: 28px;
          background: rgba(0, 0, 0, 0.5);
          border-radius: 50%;
          text-align: center;
          line-height: 28px;
          i {
            margin-top: -3px;
          }
        }
        .ejectIconZ{
          z-index:  2000;
        }
        ::v-deep .el-loading-mask {
          background: #333333;
        }
      }

    }
  }
  .transverseLine {
    width: 100%;
    height: 2px;
    background-color: #252525;
  }
  .BottomResource {
    height: calc(100% - 285px);
    display: flex;
    .LeftClassify {
      width: 64px;
      background: #333333;
      padding-bottom: 20px;
      .SortChunk {
        width: 64px;
        height: 64px;
        background: #333333;
        display: flex;
        align-items: center;
        justify-content: center;
        i {
          font-size: 22px;
          color: #666666;
        }
        p {
          width: 52px;
          font-size: 12px;
          font-weight: 400;
          color: #666666;
          line-height: 12px;
          margin: 0;
          cursor: pointer;
        }
      }
      .PitchSortChunk {
        background: #444444;
        i {
          color: #cccccc;
        }
        p {
          color: #cccccc;
        }
      }
    }
    .RightResourceList {
      width: calc(100% - 80px);
      background: #444444;
      padding: 0 7px 20px 15px;
      ::v-deep ::-webkit-scrollbar {
        /*滚动条整体样式*/
        width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
        height: 1px;
      }
      ::v-deep ::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        border-radius: 5px;
        background-color: rgb(233, 233, 233);
        opacity: 0.7;
      }
      ::v-deep ::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        border-radius: 5px;
        background: none;
      }
    }
  }
  .BigResolution{
    position: fixed;
    bottom: 29px;
    left: 50%;
    transform: translate(-50%);
    padding: 0px 8px;
    width: 400px;
    height: 32px;
    line-height: 32px;
    background: #252525;
    box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.5);
    border-radius: 4px;
    color: #DBDBDB;
    font-size: 14px;
    .icon-tishi{
      font-size: 14px;
      color: #FEB435;
    }
    .icon-tishi:before{
      font-size: 14px;
      color: #FEB435;
    }
    span {
      margin-left: 8px;
    }
  }
}
@media (max-width: 1480px) {
  .PageLeftResource {
    .BottomResource{
      height: calc(100% - 242px);
    }
  }
}
@media (max-width: 1330px) {
  .PageLeftResource {
    .BottomResource{
      height: calc(100% - 222px);
    }
  }
}
</style>
